import React, { useEffect, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

function TabletMode({ onScanResult, eventId }) {
    const scannerRef = useRef(null);

    useEffect(() => {
        const qrScanner = new Html5QrcodeScanner(
            'qr-reader',
            { 
                fps: 10, 
                qrbox: { width: 250, height: 250 },
                aspectRatio: 1.0
            },
            false
        );

        scannerRef.current = qrScanner;

        qrScanner.render(
            (decodedText) => {
                console.log('QR Code scanned:', decodedText);
                onScanResult(decodedText);
                qrScanner.pause(true);
                setTimeout(() => {
                    if (scannerRef.current) {
                        scannerRef.current.resume();
                    }
                }, 2000);
            },
            (error) => {
                // Ignore scanning errors (happens continuously)
            }
        );

        return () => {
            if (scannerRef.current) {
                scannerRef.current.clear().catch(console.error);
            }
        };
    }, [onScanResult]); // Empty dependency - only initialize once

    return (
        <div className="camera-container">
            <div id="qr-reader"></div>
        </div>
    );
}

export default TabletMode;
